import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import createHistory from "history/createBrowserHistory";
import { routerMiddleware } from "connected-react-router";
import { createLogger } from "redux-logger";
import rootSaga from "../sagas/index";
import rootReducer from "../reducers/index";
var IS_PRODUCTION = process.env.NODE_ENV === "production";
// const devTools = process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__() : null;
var composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export default (function (serverSagas, sagaOptions) {
    if (serverSagas === void 0) { serverSagas = null; }
    if (sagaOptions === void 0) { sagaOptions = {}; }
    var store = null;
    var middleware = null;
    var history = createHistory();
    var logger = createLogger();
    var rMiddleware = routerMiddleware(history);
    var sagaMiddleware = createSagaMiddleware();
    if (!IS_PRODUCTION) {
        // In development mode beside sagaMiddleware
        // logger and DevTools are added
        middleware = applyMiddleware(logger, sagaMiddleware, rMiddleware);
        store = createStore(rootReducer(history), composeEnhancer(middleware));
    }
    else {
        middleware = applyMiddleware(sagaMiddleware);
        store = createStore(rootReducer(history), composeEnhancer(middleware));
    }
    sagaMiddleware.run(rootSaga);
    return {
        history: history,
        store: store,
    };
});



//////////////////
// WEBPACK FOOTER
// ./src/config/store.ts
// module id = 254
// module chunks = 0